import { Component, OnInit, ViewChild } from "@angular/core";
import {
  GridComponent,
  TableMode,
} from "../components/grid/grid.component";
import { FieldDataType } from '../components/grid/FieldDataType';
import { ITableData } from '../components/grid/ITableData';
import { IColumn } from '../components/grid/IColumn';
import { IExam, IQuestionBank } from "../interface/dto";
import { GridUtil } from "../components/grid/GridUtil";
import { QuestionBankService } from "./question-bank.service";
import { Router } from "@angular/router";
import { EventService } from "../services/event-services/error-event.service";

@Component({
  selector: "app-questions-bank",
  templateUrl: "./questions-bank.component.html",
  styleUrls: ["./questions-bank.component.scss"],
})
export class QuestionsBankComponent implements OnInit {
  selectedBanks: IQuestionBank[] = [];

  gridName = "questionBankGrid";
  questionBanks: IQuestionBank[] = [];
  modelError = "";
  selectedBank: IQuestionBank | null = null;
  @ViewChild("gridComponent") gridComponent!: GridComponent;

  constructor(
    private questionBankService: QuestionBankService,
    private router: Router, private eventService: EventService
  ) { }

  data: ITableData = {
    tableRows: [],
    tableParams: {
      filterParams: [],
      sortParam: {
        fieldName: "",
        orderDirection: 0,
      },
      pageInfo: {
        previousPageSize: 50,
        page: 1,
        pageSize: 50,
        recordCount: 0,
        pageCount: 0,
      },
      tableMode: TableMode.serverProcessing,
      selectAll: false,
    },
  };

  columns: IColumn[] = [
    {
      displayName: "Name",
      fieldName: "name",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Description",
      fieldName: "description",
      fieldDataType: FieldDataType.text,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Question Type",
      fieldName: "questionType",
      fieldDataType: FieldDataType.enum,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "No. of Questions",
      fieldName: "noOfQuestions",
      fieldDataType: FieldDataType.number,
      searchable: true,
      orderable: true,
    },
    {
      displayName: "Disabled",
      fieldName: "disabled",
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,
    },
  ];

  async ngOnInit() {
    this.setSelectedBanks([]);
    GridUtil.setClearGridSelection();
    await this.refreshData(this.data.tableParams);
  }

  addQuestionBank() {
    this.router.navigate(["questions-bank/create"]);
  }

  editQuestionBank() {
    const selected = this.questionBankService.selectedQuestionBanks?.[0];
    if (selected) {
      this.router.navigate([`questions-bank/${selected.id}/update`]);
    }
  }

  async refreshData(tableParams) {
    const res = (await this.questionBankService.getQuestionBanks(
      tableParams
    )) as any[];
    this.updateGridParams(res);
  }

  updateGridParams(res: any) {
    if (!res) {
      return;
    }
    this.data.tableRows = [];
    const tableParams = { ...this.data.tableParams, pageInfo: res[0].pageInfo }
    this.data.tableParams = tableParams;
    this.data.tableRows.push(...res.slice(1));

     // check if any row is psychometric
     const hasPsychometric = res.slice(1).some((x: any) => x.isPsychometricTestBank === true);
     
     if (hasPsychometric) {
      this.addPsychometricColumn();
    }
    setTimeout(() => {
      this.eventService.gridDataLoadedEvent.next(true);
    });
  }

  private addPsychometricColumn() {
    const exists = this.columns.some(c => c.fieldName === 'isPsychometricTestBank');
    if (exists) return;
    
    // Insert before the last element
    const insertIndex = Math.max(this.columns.length - 1, 0);
    
    this.columns.splice(insertIndex, 0, {
      displayName: "Psychometric Bank",
      fieldName: "isPsychometricTestBank",
      fieldDataType: FieldDataType.boolean,
      searchable: true,
      orderable: true,
    });
  }

  rowSelectedEvent(rowIds: any[]) {
    if (!this.data?.tableRows?.length) { //Just in case tableRows might still not be ready
      setTimeout(() => this.rowSelectedEvent(rowIds), 50);
      return;
    }

    const storedIds = GridUtil.getSelectedDataID(this.gridName) ?? [];
    const selectedBanks: IQuestionBank[] = rowIds.map(x => this.data.tableRows[x] as IQuestionBank).filter(Boolean);

    const selectedDataRowIds =
      storedIds.length > 0 ? storedIds : selectedBanks.map((x) => x.id);

    GridUtil.setRowCliclk(this.gridName, rowIds, selectedDataRowIds);
    this.setSelectedBanks(selectedBanks);
  }

  setSelectedBanks(banks: IQuestionBank[]) {
    this.selectedBanks = banks;
    this.questionBankService.setSelectedBanks([...banks]);
  }
}
